import { Pressable, StyleSheet, Text, View } from 'react-native';
import { ContentRenderProps } from '../ContentRender';
import React, { useCallback } from 'react';
import { getUid } from '../../../store/token';
import AudioIcon from '../../../assets/svg/ic_msg_rtc_audio.svg';
import VideoIcon from '../../../assets/svg/ic_msg_rtc_video.svg';
import { MessageType } from '../../../constants/types';
import {
	Str_Canceled,
	Str_OtherEndCanceled,
	Str_OtherEndRejected,
	Str_OtherEndUnanswered,
	Str_Rejected,
	Str_RtcAudio,
	Str_RtcVideo,
	Str_Unanswered,
} from '../../../language/string_res';
import { black } from '../../../assets/style/colors';
import { formatTime } from '../../../utils/date';

export const RTCRender = (props: ContentRenderProps): React.JSX.Element => {
	const isSender = props.item.sender === getUid();
	const isVideo = props.item.type === MessageType.RTC_VIDEO;

	const handleClick = () => {
		if (props.talkSelectStatus === true) {
			return;
		}
		props.onClick?.();
	};

	const Icon = useCallback(() => {
		return isVideo ? <VideoIcon /> : <AudioIcon />;
	}, [isVideo]);

	const DisplayText = useCallback(() => {
		let text = isVideo ? Str_RtcVideo : Str_RtcAudio;
		let uId = getUid();
		if (props.item.meta) {
			const meta = props.item.meta;

			if ((meta?.duration || 0) > 0) {
				text = `通话时长  ${formatTime(meta?.duration || 0)}`;
			} else if (meta.status === -1 || meta.status === -2) {
				let uStateCaller: number | undefined = undefined; // 发送者的状态
				let uStateCallee: number | undefined = undefined; // 接收者的状态

				// 获取发送者与接受者的状态
				meta.memberList?.forEach((item: any) => {
					if ((isSender && item.userId === uId) || (!isSender && item.userId !== uId)) {
						uStateCaller = item.status;
					} else {
						uStateCallee = item.status;
					}
				});

				if (isSender) {
					// 自己发的消息
					if (uStateCallee !== -1 && uStateCallee !== -2) {
						// 说明是自己的操作 - 拨打者自己取消
						text = Str_Canceled;
					} else {
						// 说明是对方操作 - 拒绝或超时
						text = uStateCallee == -2 ? Str_OtherEndUnanswered : Str_OtherEndRejected;
					}
				} else {
					// 对方发的消息
					if (uStateCallee === -1 || uStateCallee === -2) {
						// 说明是自己的操作 - 拒绝或超时
						text = uStateCallee == -1 ? Str_Rejected : Str_Unanswered;
					} else {
						// 说明是对方操作 - 拨打者自己取消
						text = Str_OtherEndCanceled;
					}
				}
			}
		}
		return (
			<Text
				style={{
					color: black,
					fontSize: 15,
					lineHeight: 20,
				}}
			>
				{text}
			</Text>
		);
	}, [props.item.meta, isVideo]);

	const TextComponent = (
		<Pressable
			style={[
				{
					flexDirection: isSender ? 'row-reverse' : 'row',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					paddingVertical: 10,
					paddingHorizontal: 12,
					flexWrap: 'wrap',
				},
			]}
			onPress={handleClick}
			onLongPress={props.onLongPress}
			disabled={props.talkSelectStatus === true || props.disabled == true}
		>
			<Icon />
			<View style={{ width: 10 }} />
			<DisplayText />
		</Pressable>
	);

	return TextComponent;
};

const styles = StyleSheet.create({});
